import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PartyPopper, X } from 'lucide-react';

export default function PayoutMilestoneBanner() {
  const [fresh, setFresh] = useState([]);
  const [nextM, setNextM] = useState(null);
  const [total, setTotal] = useState(0);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem('cx_payout_dismissed') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    api.get('/seasons/payout_milestones').then(r => {
      setFresh(r.data.fresh || []);
      setNextM(r.data.next_milestone);
      setTotal(r.data.total_paid_usdt || 0);
    }).catch(() => {});
  }, []);

  const active = fresh.find(f => !dismissed.includes(f.threshold));
  if (!active) return null;

  const dismiss = () => {
    const next = [...dismissed, active.threshold];
    setDismissed(next);
    try { localStorage.setItem('cx_payout_dismissed', JSON.stringify(next)); } catch {}
  };

  return (
    <div className="mt-4 border border-[#0ECB81]/40 bg-gradient-to-r from-[#0ECB81]/12 via-[#0ECB81]/6 to-transparent p-3 flex items-center gap-3" data-testid="payout-milestone-banner">
      <div className="w-9 h-9 rounded-full bg-[#0ECB81]/20 border border-[#0ECB81]/50 grid place-items-center flex-shrink-0">
        <PartyPopper className="w-4 h-4 text-[#0ECB81]" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-white text-sm font-semibold" data-testid="milestone-threshold">
          🎉 {active.threshold.toLocaleString()} USDT paid to season winners — milestone unlocked!
        </div>
        <div className="text-xs text-[#B7BDC6] mt-0.5">
          Total paid: <span className="font-mono text-[#0ECB81]">{Math.round(total).toLocaleString()} USDT</span>
          {nextM && <> · next milestone: <span className="font-mono text-[#FCD535]">{nextM.toLocaleString()} USDT</span></>}
        </div>
      </div>
      <button onClick={dismiss} className="text-[#848E9C] hover:text-white" data-testid="dismiss-milestone-banner" aria-label="Dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
